<template>
   <el-cascader ref="regionDom" v-if="isShowAddressInfo"  :key="key"  :before-filter="filterRegion"
   @input.native="searchRegion"
   @visible-change="regionMenuChange"
   :options="dstOptions"
    v-model="name"
     filterable  @change="handleChange" :props="props" ></el-cascader>
</template>
<script>
import { bAreasList, findAreas } from '@/api/common'
export default {
  name: 'shengShiXian',
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      name: null,
      isShowAddressInfo: true,
      key: 1,
      dstOptions: []
    }
  },

  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (this.rowData.id) {
      this.updateAddress()
    }
  },
  methods: {
    filterRegion (value) {
      return false
    },
    regionMenuChange (boolean) {
      // true下拉框展开 false下拉框收起  展开时清掉上次搜索结果 恢复如初
      if (boolean) {
        this.$refs.regionDom.$refs.panel.activePath = []
        bAreasList({ parentId: 100000 }).then(res => {
          this.dstOption = res.map(item => ({
            value: item.areaCode,
            label: item.name
          }))
        })
      }
    },
    searchRegion (el) {
      this.$refs.regionDom.$refs.panel.clearCheckedNodes()
      this.$refs.regionDom.$refs.panel.activePath = []
      if (!el.target.value) {
        return false
      } else {
        // 这里用了防抖来限制发送频率的次数 本身cascader也有debounce属性 但这里我没有用
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          if (el.target.value.trim()) {
            findAreas({
              name: el.target.value
            }).then(res => {
              if (res.length > 0) {
                let arr = []
                res.forEach(itme => {
                  let flag = arr.some(j => j.id == itme[0].id)
                  if (!flag) {
                    arr.push(itme[0])
                  }
                })
                this.dstOptions = arr.map(item => ({
                  value: item.areaCode,
                  label: item.name,
                  children: item.children
                }))
                if (this.dstOptions[0].children && this.dstOptions[0].children[0].children) {
                  this.$nextTick(() => {
                    const firstNode = this.$refs.regionDom.$refs.panel.$el.querySelectorAll('.el-cascader-node[tabindex="-1"]')[0]
                    firstNode.click()
                    this.$nextTick(() => {
                      const firstNodeList = this.$refs.regionDom.$refs.panel.$el.querySelectorAll('.el-cascader-menu')[1]
                      const childNode = firstNodeList.querySelectorAll('.el-cascader-node[tabindex="-1"]')
                      childNode[0].click()
                    })
                  })
                } else {
                  this.$nextTick(() => {
                    const firstNode = this.$refs.regionDom.$refs.panel.$el.querySelector('.el-cascader-node[tabindex="-1"]')
                    firstNode.click()
                  })
                }
              }
            })
          } else {
            this.$refs.regionDom.panel.lazyLoad()
            bAreasList({ parentId: 100000 }).then(res => {
              this.dstOption = res.map(item => ({
                value: item.areaCode,
                label: item.name
              }))
            })
          }
        }, 500)
      }
    },

    updateAddress () {
      let data = this.rowData
      this.name = [Number(data.provinceCode), Number(data.cityCode), Number(data.areaCode)]
      this.isShowAddressInfo = false
      // 这里搞个定时器重新载入一下组件就可以触发组件拉取数据
      setTimeout(() => {
        this.isShowAddressInfo = true
      }, 0)
    },
    handleChange () {
      let seletNode = this.$refs.regionDom.getCheckedNodes()[0]
      if (seletNode) {
        let data = [
          { areaCode: seletNode.parent.parent.value, name: seletNode.parent.parent.label },
          { areaCode: seletNode.parent.value, name: seletNode.parent.label },
          { areaCode: seletNode.value, name: seletNode.label }
        ]
        this.$emit('handleChange', data)
      }
    }
  },
  computed: {
    props () {
      return {
        lazy: true,
        children: [],
        lazyLoad (node, resolve) {
          const { level } = node
          let code = level > 0 ? node.data.value : 100000
          if (node.data && node.data.children) {
            const nodes = node.data.children.map(item => ({
              value: item.areaCode,
              label: item.name,
              children: item.children,
              leaf: level >= 2
            }))
            resolve(nodes)
          } else {
            // eslint-disable-next-line vue/no-async-in-computed-properties
            bAreasList({ parentId: code }).then(res => {
              const nodes = res.map(item => ({
                value: item.areaCode,
                label: item.name,
                leaf: level >= 2
              }))
              resolve(nodes)
            })
          }
        }
      }
    }
  }
}
</script>
